// Analytics (GA4 + Meta Pixel). Nothing is loaded until the visitor accepts cookies
// in CookieBanner; after that, gatsby-browser.js sends one page view per route.

export const GA_MEASUREMENT_ID = 'G-SCN26RTCNN'
export const FB_PIXEL_ID = '1226337109257372'

const CONSENT_KEY = 'ga-consent'

// localStorage throws when storage is blocked (e.g. some privacy modes).
export function hasTrackingConsent() {
  try {
    return window.localStorage.getItem(CONSENT_KEY) === 'true'
  } catch {
    return false
  }
}

export function saveTrackingConsent() {
  try {
    window.localStorage.setItem(CONSENT_KEY, 'true')
  } catch {
    // Consent then only lasts for the current visit.
  }
}

export function loadTrackers() {
  loadGA4(GA_MEASUREMENT_ID)
  loadFBPixel(FB_PIXEL_ID)
}

function loadGA4(measurementId) {
  if (window.gtag) return

  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  // Page views are sent by trackPageView() so they aren't counted twice.
  window.gtag('config', measurementId, { anonymize_ip: true, send_page_view: false })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  document.head.appendChild(script)
}

function loadFBPixel(pixelId) {
  if (window.fbq) return

  // Meta Pixel base code: fbq() queues calls until fbevents.js loads and takes over.
  const fbq = function () {
    fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments)
  }
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []
  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  fbq('init', pixelId)
}

export function trackPageView(path = window.location.pathname + window.location.search) {
  // Wait two frames so the Head API has set the new page's document.title.
  requestAnimationFrame(() =>
    requestAnimationFrame(() => {
      window.gtag?.('event', 'page_view', { page_path: path })
      window.fbq?.('track', 'PageView')
    })
  )
}
